export class Bus<MessageType> {
  private subscribers: Set<(msg: MessageType) => void> = new Set();

  constructor() {}

  broadcast(msg: MessageType): void {
    this.subscribers.forEach((subscriber) => subscriber(msg));
  }

  subscribe(callback: (msg: MessageType) => void): () => void {
    this.subscribers.add(callback);
    // return unsubscribe function
    return () => {
      this.subscribers.delete(callback);
    };
  }
}
